import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

const setCalendarCountriesReducer = (state: DesignState, action: PayloadAction<string[]>) => {
  if (!state.designData) {
    return;
  }

  state.designData.calendar = {
    ...state.designData.calendar,
    countries: action.payload,
  };
};

export default setCalendarCountriesReducer;
